// eslint-disable-next-line import/prefer-default-export
export const BODY_OK = {
  access_token: '3b6b9af9bf8f7319e7c468b8003f85d0',
  refresh_token: '7c36c4a5a6038da6bc8edb93969c2b9d',
  expires_in: 3600,
};
